import envs from "../envs";

export const home = "/paravoce/habitacional";
export const emprestimos = "/paravoce/emprestimos";

export const mapaCondicoesGerais =
  "/AreaAberta/Habitacional/CondicoesGerais/Condicoes-Gerais.json";

export const cartilhaSeguroHabitacional = `${envs.hostStaticCdn}/AreaAberta/Habitacional/Cartilhas/Cartilha-Seguro-Habitacional.pdf`;

export const internetBanking = `${envs.internetBankingHabitacional}`;
export const abnt = `${envs.abnt}`;

export const areaLogada = `${envs.hostAreaLogada}/login/residencial`;
